
<div class="container" style="padding-top: 1%">
  <h2>Adăugare Comandă</h2>
</div>
<div class="container" style="padding-top: 2%">
  <form #inputOrderForm="ngForm" (ngSubmit)="addOrder(inputOrderForm)" (keydown.enter)="$event.preventDefault()" [formGroup]="ordersForm">
    <div class="form-group row">
      <label for="PO" class="col-sm-2 col-form-label">PO</label>
      <div class="col-sm-4">
        <input name="PO" ngModel [ngClass]="{'is-invalid' : ordersForm.controls.PO.invalid}" formControlName="PO" class="form-control" id="po" placeholder="PO1342" required>
        <p *ngIf="ordersForm.controls.PO.errors?.required" style="margin-top: 7px; font-size: 12px" class="text-danger">Câmpul este obligatoriu!</p>
        <p *ngIf="ordersForm.controls.PO.errors?.pattern && !ordersForm.controls.PO.errors?.required" style="margin-top: 7px; font-size: 12px" class="text-danger">Formatul PO-ului nu este corect!</p>
      </div>


      <label for="numarFactura" class="col-sm-2 col-form-label">Număr Factură</label>
      <div class="col-sm-4">
        <input name="NumarFactura" ngModel [ngClass]="{'is-invalid' : ordersForm.controls.NumarFactura.invalid}" formControlName="NumarFactura" class="form-control" id="numarFactura" placeholder="FF-8907" required>
        <p *ngIf="ordersForm.controls.NumarFactura.invalid" style="margin-top: 7px; font-size: 12px" class="text-danger">Câmpul este obligatoriu!</p>
      </div>


    </div>
    <div class="form-group row">
      <label for="dataReceptie" class="col-sm-2 col-form-label">Dată recepție</label>
      <div class="col-sm-4">
        <mat-form-field  id=dataReceptie appearance="fill">
          <mat-label>Dată Recepție</mat-label>
          <input matInput [matDatepicker]="picker" name="DataReceptie" formControlName="DataReceptie" [ngClass]="{'is-invalid' : ordersForm.controls.DataReceptie.invalid}">
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker touchUi #picker></mat-datepicker>
          <p *ngIf="ordersForm.controls.DataReceptie.invalid" style="margin-top: 7px; font-size: 12px" class="text-danger">Câmpul este obligatoriu!</p>
        </mat-form-field>
      </div>

      <label for="conditieLivrare" class="col-sm-2 col-form-label">Condiție de livrare</label>
      <div class="col-sm-4">
        <select name="ConditieLivrare" ngModel [ngClass]="{'is-invalid' : ordersForm.controls.ConditieLivrare.invalid}" formControlName="ConditieLivrare" class="form-control" id="conditieLivrare" >
          <option selected></option>
          <option *ngFor="let incoterm of incoterms">{{incoterm}}</option>
        </select>
        <p *ngIf="ordersForm.controls.ConditieLivrare.errors?.required" style="margin-top: 7px; font-size: 12px" class="text-danger">Câmpul este obligatoriu!</p>
      </div>

    </div>

    <h3>Linii Comandă</h3>
    <div class="row" style="padding-left: 4px">
      <div class="container-fluid" style="padding: 1%">
        <table class="table table-responsive-sm">
          <thead>
          <tr>
            <th style="width: 20%">
              Part Number
            </th>
            <th style="width: 10%">
              Cantitate
            </th>
            <th style="width: 20%">
              Piesă
            </th>
            <th style="width: 20%">
              Țară de Expediere
            </th>
            <th>
            </th>
          </tr>
          </thead>
          <tbody>
            <tr>
              <td style="width: 12%">
                <input
                  id="typeahead-focus"
                  type="text"
                  class="form-control"
                  placeholder="FG-61F-BDL950-36"
                  [(ngModel)]="currentPartNumber"
                  [ngModelOptions]="{standalone: true}"
                  (ngModelChange)="refreshParts()"
                  [ngbTypeahead]="search"
                  (focus)="focus$.next($any($event).target.value)"
                  (click)="click$.next($any($event).target.value)"
                  #instance="ngbTypeahead"
                />
              </td>
              <td>
                <input class="form-control" [(ngModel)]="currentQuantity" [ngModelOptions]="{standalone: true}" (keyup.enter)="addLine()" type="number" placeholder="0">
              </td>
              <td>
                <select [(ngModel)]="currentPart" [ngModelOptions]="{standalone: true}" class="form-control" id="piesa">
                  <option value="" selected></option>
                  <option *ngFor="let part of parts">{{part}}</option>
                </select>
              </td>
              <td>
                <select [(ngModel)]="currentCountryOfExpedition" [ngModelOptions]="{standalone: true}" class="form-control" id="taraOrigine">
                  <option value="" selected></option>
                  <option *ngFor="let country of countries">{{country}}</option>
                </select>
              </td>
              <td>
                <button
                  type="button" class="btn btn-outline-success" (click)="addLine()" style="margin: 1%">Adaugă <i class="bi bi-plus-lg"></i>
                </button>
              </td>
            </tr>
            <tr *ngFor="let key of lines.keys()">
              <td>
                {{key.split('\t')[0].toUpperCase()}}
              </td>
              <td>
                {{lines.get(key)}}
              </td>
              <td>
                {{key.split('\t')[1]}}
              </td>
              <td>
                {{linesCountries.get(key)}}
              </td>
              <td>
                <button
                  type="button" class="btn btn-outline-info" (click)="modifyLineDetails(modalLinesDetails, key.split('\t')[0], key.split('\t')[1])" style="margin: 1%">Modifică <i class="far fa-edit"></i>
                </button>
                <button
                  type="button" class="btn btn-outline-danger" (click)="deleteLine(key.split('\t')[0], key.split('\t')[1])" style="margin: 1%">Șterge <i class="bi bi-trash"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row">
      <button class="btn btn-warning" style="margin: 1%" (click)="cancelAddOrder()"><i class="far fa-times-circle"></i> Anulare</button>
      <button
        *ngIf="!ordersForm.controls.PO.invalid && !ordersForm.controls.NumarFactura.invalid && !ordersForm.controls.ConditieLivrare.invalid"
        type="submit" class="btn btn-success" style="margin: 1%"><i class="fas fa-plus-circle"></i> Adăugare</button>
      <button
        *ngIf="ordersForm.controls.PO.invalid || ordersForm.controls.NumarFactura.invalid || ordersForm.controls.ConditieLivrare.invalid"
        class="btn btn-success disabled" style="margin: 1%" disabled><i class="fas fa-plus-circle"></i> Adăugare</button>
    </div>
  </form>

</div>

<ng-template #modalLinesDetails let-modalLinesDetails>
  <div class="modal-header">
    <h4 class="modal-title">Modificare detalii {{this.currentModifiablePartNo}}</h4>
  </div>
  <div class="modal-body">
    <div style="margin-bottom: 2%">
      <p *ngIf='currentModifiableQuantity != linesDetails.get(this.currentModifiablePartNo + "\t" + this.currentModifiablePartName).mac.length || currentModifiableQuantity != linesDetails.get(this.currentModifiablePartNo + "\t" + this.currentModifiablePartName).sn.length' class="text-warning">Cantitatea liniei nu corespunde cu numărul de MAC-uri sau Serial Number-e introduse</p>
      <label for="modifyQuantity">Cantitate </label>
      <input id="modifyQuantity" class="form-control" [(ngModel)]="currentModifiableQuantity" [ngModelOptions]="{standalone: true}" type="number">
    </div>
    <div style="margin-bottom: 2%">
      <label for="countryOfExpedition">Țară de Expediție </label>
      <select [(ngModel)]="currentModifiableCountryOfExpedition" [ngModelOptions]="{standalone: true}" class="form-control" id="countryOfExpedition">
        <option value="{{linesCountries.get(this.currentModifiablePartNo)}}" selected>{{linesCountries.get(this.currentModifiablePartNo)}}</option>
        <option *ngFor="let country of countries">{{country}}</option>
      </select>
    </div>
    <ngb-accordion [closeOthers]="true">
      <ngb-panel id="sn">
        <ng-template ngbPanelTitle>
          <span>Serial number</span>
        </ng-template>
        <ng-template ngbPanelContent>
          <table class="table">
            <thead>
              <tr>
                <th  scope="col" style="width: 60%">
                  Serial Number
                </th>
                <th  scope="col" style="width: 40%">

                </th>
              </tr>
            </thead>
            <tbody>
            <tr>
              <th>
                <input class="form-control" [(ngModel)]="currentSN" [ngModelOptions]="{standalone: true}" (keyup.enter)="addSN()" type="text">
              </th>
              <th>
                <button
                  type="button" class="btn btn-outline-success" (click)="addSN()" style="margin: 1%">Adaugă <i class="bi bi-plus-lg"></i>
                </button>
              </th>
            </tr>
            <tr *ngFor="let sn of getSNPage()">
              <th style="width: 60%;font-weight:normal;">
                {{sn}}
              </th>
              <th style="width: 40%">
                <button
                  type="button" class="btn btn-outline-danger" (click)="deleteSN(sn)" style="margin: 1%">Șterge <i class="bi bi-trash"></i>
                </button>
              </th>
            </tr>
            </tbody>
          </table>
          <div *ngIf="numberOfOrderPagesSN > 1" class="row">
            <button class="btn btn-info" style="margin: 2px" type="button" (click)="goToPrevPageSN()"><i class="bi bi-chevron-left"></i></button>
            <div style="margin: 4px; font-size: 19px">{{currentOrderPageSN}} / {{numberOfOrderPagesSN}}</div>
            <button class="btn btn-info" style="margin: 2px" type="button" (click)="goToNextPageSN()"><i class="bi bi-chevron-right"></i></button>
          </div>
        </ng-template>
      </ngb-panel>
      <ngb-panel id="mac">
        <ng-template ngbPanelTitle>
          <span>MAC</span>
        </ng-template>
        <ng-template ngbPanelContent>


          <table class="table">
            <thead>
            <tr>
              <th  scope="col" style="width: 60%">
                MAC
              </th>
              <th  scope="col" style="width: 40%">

              </th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <th>
                <input class="form-control" [(ngModel)]="currentMAC" [ngModelOptions]="{standalone: true}" (keyup.enter)="addMAC()" type="text">
              </th>
              <th>
                <button
                  type="button" class="btn btn-outline-success" (click)="addMAC()" style="margin: 1%">Adaugă <i class="bi bi-plus-lg"></i>
                </button>
              </th>
            </tr>
            <tr *ngFor="let mac of getMACPage()">
              <th style="width: 60%;font-weight:normal;">
                {{mac}}
              </th>
              <th style="width: 40%">
                <button
                  type="button" class="btn btn-outline-danger" (click)="deleteMAC(mac)" style="margin: 1%">Șterge <i class="bi bi-trash"></i>
                </button>
              </th>
            </tr>
            </tbody>
          </table>
          <div *ngIf="numberOfOrderPagesMAC > 1" class="row">
            <button class="btn btn-info" style="margin: 2px" type="button" (click)="goToPrevPageMAC()"><i class="bi bi-chevron-left"></i></button>
            <div style="margin: 4px; font-size: 19px">{{currentOrderPageMAC}} / {{numberOfOrderPagesMAC}}</div>
            <button class="btn btn-info" style="margin: 2px" type="button" (click)="goToNextPageMAC()"><i class="bi bi-chevron-right"></i></button>
          </div>


        </ng-template>
      </ngb-panel>
    </ngb-accordion>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-warning" (click)="restoreLinesDetailsModifications(modalLinesDetails)"><i class="far fa-times-circle"></i> Anulare</button>
    <button type="button" class="btn btn-success" (click)="applyLinesDetailsModifications(modalLinesDetails)"><i class="bi bi-check-lg"></i> Aplicare</button>
  </div>
</ng-template>
